module.exports = __webpack_public_path__ + "static/media/1kmountains.2c83caf2.jpg";